// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1__KK","cls2":"BulkFollowSuggestion-cls2_vlt BulkFollowSuggestion-cls1__KK"};